import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { IEnviarMensagemAtiva , IMensagemTemplate} from "../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import { EnviarMensagemAtivaServices } from "../../../Services/HelpDesk/Atendimento/AtendimentoServices";
import { ListarMensagensTemplate } from "../../../Services/HelpDesk/GestaoAtendimentos/GestaoAtendimentosService";
import { IError, ValidationErr } from "../../../Validations/ValidationError";

interface IuseWhatsappAtivo {
    setModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export function useWhatsappAtivo({ setModal }: IuseWhatsappAtivo) {
    //States
    const history = useHistory();
    const [lstMessage, setLstMessage] = useState<IMensagemTemplate[]>([]);
    const [inputShow, setInputShow] = useState<Boolean>(false);
    async function SendMessage(props: IEnviarMensagemAtiva) {
        const body: IEnviarMensagemAtiva = {
            numDestino: props.numDestino.replace(/\D/g, ""),
            ddiNumDestino: props.ddiNumDestino,
            idTemplate: props.idTemplate,
            VariaveisTemplate: props.VariaveisTemplate
        };
        if (props.numDestino) {
            await EnviarMensagemAtivaServices(body)
                .then((response) => {
                    if (response.status === 200) {
                        setModal(false);
                        history.push("/HelpDesk/Atendimento");
                    }
                })
                .catch((err) => {
                    ValidationErr(err);
                    throw err;
                });
        } else {
            ValidationErr({
                data: {
                    title: "Não foi possivel enviar a mensagem",
                    ErroInformal: "Por favor Digite um Telefone Valido",
                },
                status: 404,
            } as IError);
        }
    }
    async function lstMensagemTemplate() {
        await ListarMensagensTemplate()
            .then((response) => {
                if (response.status === 200) {
                    setLstMessage(response.data);
                }
            })
            .catch((err) => {
                ValidationErr(err);
                throw err;
            }); 
    }
    useEffect(() => {
        lstMensagemTemplate();
    }, []);
    return { SendMessage, lstMessage, inputShow, setInputShow };
}
